var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    width: 89.279,
    height: 59.325,
    viewBox: "0 0 89.279 59.325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28158",
    transform: "translate(-196.632 -9.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20803",
    d: "M215.014 28.561a8.006 8.006 0 1 1 8.006-8.006 8.012 8.012 0 0 1-8.006 8.006zm0-13.832a5.826 5.826 0 1 0 5.826 5.826 5.832 5.832 0 0 0-5.826-5.826z",
    className: "cls-1",
    transform: "translate(26.255 7.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20804",
    d: "M235.962 43.844H205.88a1.09 1.09 0 0 1-1.09-1.09v-19.27a4.675 4.675 0 0 1 2.966-4.33l6.057-2.344a1.088 1.088 0 0 1 1.229.315 7.679 7.679 0 0 0 11.759 0 1.087 1.087 0 0 1 1.229-.315l6.053 2.344a4.673 4.673 0 0 1 2.97 4.33v19.27a1.09 1.09 0 0 1-1.091 1.09zm-28.992-2.18h27.9v-18.18a2.475 2.475 0 0 0-1.576-2.3l-5.358-2.074a9.877 9.877 0 0 1-14.033 0l-5.358 2.074a2.447 2.447 0 0 0-1.576 2.3z",
    className: "cls-1",
    transform: "translate(20.35 18.152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20805",
    d: "M217.064 27.435h-2.18a1.09 1.09 0 0 1 0-2.18h2.18a1.09 1.09 0 1 1 0 2.18z",
    className: "cls-1",
    transform: "translate(44.278 40.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20806",
    d: "M229.1 27.435h-4.162a1.09 1.09 0 1 1 0-2.18h4.162a1.09 1.09 0 1 1 0 2.18zm-8.321 0h-4.158a1.09 1.09 0 1 1 0-2.18h4.158a1.09 1.09 0 0 1 0 2.18z",
    className: "cls-1",
    transform: "translate(48.885 40.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20807",
    d: "M223.347 27.435h-2.18a1.09 1.09 0 1 1 0-2.18h2.18a1.09 1.09 0 1 1 0 2.18z",
    className: "cls-1",
    transform: "translate(60.974 40.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20808",
    d: "M259.161 27.435h-60.94a1.09 1.09 0 0 1 0-2.18h60.94a1.09 1.09 0 0 1 0 2.18z",
    className: "cls-1",
    transform: "translate(0 40.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20809",
    d: "M207.469 34.407a1.09 1.09 0 0 1-1.09-1.09V21.376a1.09 1.09 0 1 1 2.18 0v11.941a1.09 1.09 0 0 1-1.09 1.09z",
    className: "cls-1",
    transform: "translate(24.573 27.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20810",
    d: "M212.516 34.407a1.09 1.09 0 0 1-1.09-1.09V21.376a1.09 1.09 0 1 1 2.18 0v11.941a1.09 1.09 0 0 1-1.09 1.09z",
    className: "cls-1",
    transform: "translate(37.985 27.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20811",
    d: "M222.676 25.916a8.006 8.006 0 1 1 8-8.006 8.013 8.013 0 0 1-8 8.006zm0-13.832a5.826 5.826 0 1 0 5.824 5.826 5.832 5.832 0 0 0-5.824-5.826z",
    className: "cls-1",
    transform: "translate(46.605 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20812",
    d: "M215.127 31.762a1.09 1.09 0 0 1-1.09-1.09V18.731a1.09 1.09 0 0 1 2.18 0v11.941a1.09 1.09 0 0 1-1.09 1.09z",
    className: "cls-1",
    transform: "translate(44.923 20.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20813",
    d: "M220.174 31.762a1.09 1.09 0 0 1-1.09-1.09V18.731a1.09 1.09 0 0 1 2.18 0v11.941a1.09 1.09 0 0 1-1.09 1.09z",
    className: "cls-1",
    transform: "translate(58.335 20.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20814",
    d: "M243.62 41.2h-28.008a1.09 1.09 0 0 1-1.09-1.09v-9.6a2.473 2.473 0 0 0-1.437-2.231 1.085 1.085 0 0 1-.636-.987v-6.454a4.673 4.673 0 0 1 2.97-4.33l6.053-2.344a1.094 1.094 0 0 1 1.229.315 7.679 7.679 0 0 0 11.758 0 1.094 1.094 0 0 1 1.229-.315l6.057 2.344a4.675 4.675 0 0 1 2.966 4.33v19.271a1.09 1.09 0 0 1-1.091 1.091zm-26.92-2.181h25.83V20.838a2.479 2.479 0 0 0-1.576-2.3l-5.354-2.071a9.868 9.868 0 0 1-14.033 0l-5.367 2.074a2.479 2.479 0 0 0-1.576 2.3v5.819a4.644 4.644 0 0 1 2.074 3.855z",
    className: "cls-1",
    transform: "translate(40.701 11.124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20815",
    d: "M207.359 25.916a8.006 8.006 0 1 1 8.006-8.006 8.015 8.015 0 0 1-8.006 8.006zm0-13.832a5.826 5.826 0 1 0 5.826 5.826 5.835 5.835 0 0 0-5.826-5.826z",
    className: "cls-1",
    transform: "translate(5.902 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20816",
    d: "M204.858 31.762a1.09 1.09 0 0 1-1.09-1.09V18.731a1.09 1.09 0 0 1 2.18 0v11.941a1.09 1.09 0 0 1-1.09 1.09z",
    className: "cls-1",
    transform: "translate(17.634 20.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20817",
    d: "M199.811 31.762a1.09 1.09 0 0 1-1.09-1.09V18.731a1.09 1.09 0 0 1 2.18 0v11.941a1.093 1.093 0 0 1-1.09 1.09z",
    className: "cls-1",
    transform: "translate(4.223 20.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20818",
    d: "M226.23 41.2h-28.008a1.09 1.09 0 0 1-1.09-1.09V20.838a4.675 4.675 0 0 1 2.966-4.33l6.057-2.344a1.089 1.089 0 0 1 1.225.315 7.683 7.683 0 0 0 11.762 0 1.093 1.093 0 0 1 1.229-.315l6.053 2.344a4.673 4.673 0 0 1 2.97 4.33v6.455a1.085 1.085 0 0 1-.636.987 2.473 2.473 0 0 0-1.437 2.231v9.6a1.09 1.09 0 0 1-1.091 1.089zm-26.918-2.18h25.828v-8.508a4.649 4.649 0 0 1 2.07-3.855v-5.819a2.481 2.481 0 0 0-1.573-2.3l-5.362-2.074a9.864 9.864 0 0 1-14.03 0l-5.362 2.074a2.449 2.449 0 0 0-1.573 2.3z",
    className: "cls-1",
    transform: "translate(0 11.124)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentIcon);
export default __webpack_public_path__ + "static/media/agent-icon.2cc56aea.svg";
export { ForwardRef as ReactComponent };